import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import '../AIInterviewEnrolledCourse/Interview.css';

const ExamEndedUnenrolledCourse = () => { 
  const navigate = useNavigate(); 

  return (
    <div className="exam-ended-container">
           <p  >The exam has ended.</p>
          <button className="certificate-btn" onClick={() => navigate("/")}>Go to Home</button>
        </div>
  );
};

export default ExamEndedUnenrolledCourse;
